import { render, staticRenderFns } from "./BedManagementForm.vue?vue&type=template&id=48cfceba"
import script from "./BedManagementForm.vue?vue&type=script&lang=js"
export * from "./BedManagementForm.vue?vue&type=script&lang=js"
import style0 from "./BedManagementForm.vue?vue&type=style&index=0&id=48cfceba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports